import React from "react";
import { Link, useParams } from "react-router-dom";
import carouselData from "../../../data/carouselData";
import kakao from "../../../assets/img/carousel/story/kakao.png";
import link from "../../../assets/img/carousel/story/link.png";

// 사진
import img1 from "../../../assets/img/carousel/fleamarket/1.JPG";
import img2 from "../../../assets/img/carousel/fleamarket/2.JPG";
import img3 from "../../../assets/img/carousel/fleamarket/3.JPG";
import img4 from "../../../assets/img/carousel/fleamarket/4.JPG";
import img5 from "../../../assets/img/carousel/fleamarket/5.JPG";
import img6 from "../../../assets/img/carousel/fleamarket/6.JPG";
import img7 from "../../../assets/img/carousel/fleamarket/7.JPG";
import img8 from "../../../assets/img/carousel/fleamarket/8.JPG";

function FleaMarket() {
  return (
    <div className="2xl:w-[60%] w-[90%] mx-auto md:mt-10 mt-5 flex flex-col gap-32">
      {/* <h2>Story {id}</h2> */}
      {/* 상단 */}
      <div className="flex flex-col items-center gap-1 md:gap-3">
        <div className="flex text-sm md:text-base lg:text-lg">
          <p>제작</p>
          <p>&nbsp;|&nbsp;</p>
          <p>2022-09</p>
        </div>
        <p className="flex flex-col gap-1 text-lg font-semibold text-center md:text-2xl lg:text-4xl">
          <p>청년 창업가와 지역주민을 위한</p>
          <p>오월첫동네 플리마켓</p>
        </p>
        {/* <div className="flex gap-3 mt-1 md:mt-3">
          <div className="w-8 p-2 rounded-full md:w-10 bg-boxbg hover:bg-boxbg2">
            <img src={kakao} alt="" className="object-cover" />
          </div>
          <div className="w-8 p-2 rounded-full md:w-10 bg-boxbg hover:bg-boxbg2">
            <img src={link} alt="" className="object-cover" />
          </div>
        </div> */}
      </div>
      {/* 내용 */}
      <div className="flex flex-col items-center gap-5 text-center md:gap-10">
        <div className="flex flex-col gap-1 md:gap-3">
          <div className="flex w-full">
            <img
              className="object-cover w-full aspect-video"
              src={img1}
              alt=""
            />
          </div>
          <div className="flex w-full">
            <img
              className="object-cover w-full aspect-video"
              src={img2}
              alt=""
            />
          </div>
          <div className="flex w-full">
            <img
              className="object-cover w-full aspect-video"
              src={img3}
              alt=""
            />
          </div>
          <div className="flex w-full">
            <img
              className="object-cover w-full aspect-video"
              src={img4}
              alt=""
            />
          </div>
          <div className="flex w-full">
            <img
              className="object-cover w-full aspect-video"
              src={img5}
              alt=""
            />
          </div>
          <div className="flex w-full">
            <img
              className="object-cover w-full aspect-video"
              src={img6}
              alt=""
            />
          </div>
          <div className="flex w-full">
            <img
              className="object-cover w-full aspect-video"
              src={img7}
              alt=""
            />
          </div>
          <div className="flex w-full">
            <img
              className="object-cover w-full aspect-video"
              src={img8}
              alt=""
            />
          </div>
          <p className="text-sm md:text-lg">오월첫동네 플리마켓</p>
        </div>
      </div>
      {/* 하단 */}
      <div className="flex flex-col items-center gap-1 md:gap-3">
        {/* <div className="flex gap-3">
          <div className="w-8 p-2 rounded-full md:w-10 bg-boxbg hover:bg-boxbg2">
            <img src={kakao} alt="" className="object-cover" />
          </div>
          <div className="w-8 p-2 rounded-full md:w-10 bg-boxbg hover:bg-boxbg2">
            <img src={link} alt="" className="object-cover" />
          </div>
        </div> */}
        <Link to="/">
          <button className="h-8 mt-3 text-base rounded-full w-28 md:h-10 bg-boxbg hover:bg-boxbg2">
            이전으로
          </button>
        </Link>
      </div>
    </div>
  );
}

export default FleaMarket;
